import React from 'react';
import Loader from 'shared/Loader';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import EngagementsForm from '@EngagementsForm/EngagementsForm';
import { useActionPermission } from 'core/hooks/useActionPermission';
import { ACTIONS_WIRELINE_ENGAGEMENTS_PATHS } from 'core/models/actionsPermissions';
import ScopeDescription from 'pages/WirelineEngagements/WirelineEngagementsCreate/EngagementFormsWrapper/ScopeDescription';
import { useWirelineEngagementsCreateContext } from 'pages/WirelineEngagements/WirelineEngagementsCreate/WirelineEngagementsCreateContext';
import WirelineEngagementsCreateBackButton from 'pages/WirelineEngagements/WirelineEngagementsCreate/WirelineEngagementsCreateBackButton';
import './EngagementFormsWrapper.scss';

const EngagementFormsWrapper = () => {
  const { wirelineEngagementId } = useParams();
  const { isInitializing } = useWirelineEngagementsCreateContext();
  const isAvailableGetScopeDescription = useActionPermission(
    ACTIONS_WIRELINE_ENGAGEMENTS_PATHS.SCOPE_DESCRIPTION_GET,
  );

  const isVisibleScopeDescription = !!wirelineEngagementId && isAvailableGetScopeDescription;

  if (isInitializing) {
    return <Loader />;
  }

  return (
    <Box className="engagements-forms__wrapper">
      <WirelineEngagementsCreateBackButton />
      <EngagementsForm />
      {isVisibleScopeDescription && <ScopeDescription />}
    </Box>
  );
};

export default EngagementFormsWrapper;
